// extracted by mini-css-extract-plugin
export var banner = "_nk-0";
export var settingRow = "_nk-2";
export var titleIcon = "_nk-1";